import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { ExamStepEnum } from 'src/services/offline/db';
import { getOrderIDB } from 'src/services/offline/outboxClient';

import useRemoteBoundStore from 'src/store/useRemoteBoundStore';

import { I18NextNS } from 'src/models/Language.model';

const useNavigateAfterConfirm = () => {
  const history = useHistory();
  const { t } = useTranslation(I18NextNS.COMMON);
  const navigateAfterConfirm = async () => {
    const { session } = useRemoteBoundStore.getState();

    if (!session.orderId) {
      throw new Error(t('message.error.orderNotFound'));
    }

    const order = await getOrderIDB(session.orderId).catch(() => undefined);

    const baseState = {
      isResume: order?.LastStep !== undefined,
    };

    switch (order?.LastStep) {
      case ExamStepEnum.EXAM_HINT:
        history.push({ pathname: '/session-hint', state: baseState });
        break;
      case ExamStepEnum.ANALYSIS:
        history.push({
          pathname: '/session-preview',
          state: { ...baseState, openAnalysis: true },
        });
        break;
      case ExamStepEnum.IMAGING:
        history.push({ pathname: '/session-preview', state: baseState });
        break;
      case ExamStepEnum.DIABETES_DATA:
        history.push({ pathname: '/diabetes-data', state: baseState });
        break;
      default:
        history.push({ pathname: '/diabetes-data', state: baseState });
    }
  };

  return navigateAfterConfirm;
};

export default useNavigateAfterConfirm;
